import React from 'react';
import { Button } from '@material-ui/core';
import { FormattedMessage } from 'react-intl';

type Props = {
    onClick: () => void;
};

const PathPreviewButton = ({ onClick }: Props): React.ReactElement => (
    <Button className="yeself-preview-button" color="primary" onClick={onClick}>
        <FormattedMessage id="PropertiesPosition.button.element.preview" defaultMessage="Preview" />
    </Button>
);

export default PathPreviewButton;
